<template>
    <AdminLayout>
        <section class="flex items-start px-14 space-x-9">
            <div class="w-full">
                <div class="mt-12">
                    <div class="border rounded-lg py-7 px-8">
                        <div class="flex justify-between">
                            <p class="font-semibold text-xl text-neutral-800">Country List</p>
                            <div class="flex items-center">
                                <!-- <p class="text-sm">Status:</p> -->
                                <!-- <div class="w-28 ml-3">
                                    <DropDown :options="attendanceStatus" :message="`Select Option`" v-model="selectedAttendance" />
                                </div> -->
                                <!-- <button class="ml-3 btn-primary-light flex items-center">
                                    <span>
                                        <ArrowDownTrayIcon class="w-4 h-4"/>
                                    </span>
                                    <span class="pl-2">
                                        Download
                                    </span>
                                </button> -->
                               
                                <!-- <button class="ml-3 btn-primary-light flex items-center"> -->
                                    <!-- <span>
                                        <ArrowDownTrayIcon class="w-4 h-4"/>
                                    </span> -->
                                    <!-- <router-link to="/add-country" @click="this.isSidebar = true">
                                        <span class="pl-2">
                                            Add Country
                                        </span>
                                    </router-link> -->
                                    
                                <!-- </button> -->
                            </div>
                        </div>



                        <div class=" overflow-x-auto sm:rounded-lg pt-5">
                            <table v-if="isLoading" class="w-full text-sm text-left text-neutral-500 ">
                                <thead class="text-xs bg-neutral-300/50 uppercase animate-pulse">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            <span class="w-28 rounded h-5 bg-neutral-300 inline-block"></span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="animate-pulse">
                                    <tr class="bg-white border-b border-neutral-100">
                                        
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                    </tr>
                                    <tr class="bg-white border-b border-neutral-100">
                                        
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                    </tr>
                                    <tr class="bg-white border-b border-neutral-100">
                                        
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                    </tr>
                                    <tr class="bg-white border-b border-neutral-100">
                                        
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                    </tr>
                                    <tr class="bg-white border-b border-neutral-100">
                                        
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                    </tr>
                                    <tr class="bg-white border-b border-neutral-100">
                                        
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                    </tr>
                                    <tr class="bg-white border-b border-neutral-100">
                                        
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                    </tr>
                                    <tr class="bg-white border-b border-neutral-100">
                                        
                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                        <td class="px-6 py-4">
                                            <span class="w-28 rounded h-5 bg-neutral-200 inline-block"></span>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>

                            <table v-else class="glob_table w-full text-sm text-left text-neutral-500">
                                <thead class="bg-[#ECF6FF]">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            ID
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            Country Name
                                        </th>
                                        <th scope="col" class="px-6 py-3 font-semibold">
                                            Country Code
                                        </th>
                                     
                                    </tr>
                                </thead>
                               
                                <tbody v-if="countryList.length > 0" >
                                    <tr v-for="(country,index) in countryList" :key="country.id" class="bg-white border-b">
                                        <td scope="row" class="px-6 py-4 font-medium text-neutral-700 whitespace-nowrap">
                                            #{{ index+1 }}
                                        </td>
                                        <td class="px-6 py-4">
                                            <div class="flex items-center">{{ country.name }}</div>
                                        </td>
                                        <td class="px-6 py-4">
                                            <div class="flex items-center">{{ country.code }}</div>
                                        </td>                                    
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <div class="flex pt-5 justify-end">
                                        <MultiPageComponent :page="pageData?.page" :totalPages="pageData?.totalPages"
                                        @page-change="handlePageChange" />
                                    </div>
                                        </td>
                                    </tr>
                                </tbody>                             
                            </table>
                        </div>

                    </div>
                </div>
            </div>
            <!-- <RightSideBar/> -->
        </section>
    </AdminLayout>
</template>
<script>
    import AdminLayout from '../AdminDashboard/AdminLayout.vue';
    // import RightSideBar from '../../components/RightSideBar.vue';
    import axios from "axios";
    import { BASE_URL } from "../../config";
    import MultiPageComponent from "../../components/Widgets/MultiPageComponent.vue";

    export default {
        name: 'CountryList',
        components:{
            AdminLayout,
            // RightSideBar,
            MultiPageComponent
        },
        data() {
            return {
                countryList: [],
                currentPage: 1,
                pageData: {},
                isLoading: false,
            }
        },
        created(){
            this.currentPage = this.$route.query.page ? this.$route.query.page : 1;
            this.getCountryList();
        },
        methods:{
            async getCountryList() {
                this.isLoading = true;
                try {
                    const response = await axios.get(BASE_URL + `/country-list?page=${this.currentPage}&limit=10`);
                    this.countryList = response.data.countryList;
                    this.pageData = response.data.pagination;
                    console.log("COUNTRY LIST:: ", response.data);
                } catch (error) {
                    console.error("Error fetching country list:", error);
                } finally {
                    this.isLoading = false; // Stop loader ✅
                }
            },
            handlePageChange(newPage) {
                if (this.$route.query.page === newPage) return
                const query = { ...this.$route.query }
                if (newPage) query.page = newPage
                else delete query.page
                this.$router.replace({ query })
                this.currentPage = newPage;
                this.getCountryList();
            }
        }
            
    }
</script>